import { Component, computed, inject, input, output, Signal } from '@angular/core';
import {
  getLabelPreviewBgSmallUrl,
  LABEL_PREVIEW_BACKGROUNDS,
  LabelPreviewBackgroundId,
  labelPreviewBgThumbStyle,
  resolveLabelPreviewBgId,
} from '../label-preview-backgrounds';
import { ResponsiveService } from '../../services/responsive.service';

@Component({
  selector: 'app-label-preview-background-picker',
  templateUrl: './label-preview-background-picker.component.html',
  styleUrl: './label-preview-background-picker.component.scss',
  host: {
    '[class.is-mobile]': 'isMobile()',
  },
})
export class LabelPreviewBackgroundPickerComponent {
  selectedId = input.required<LabelPreviewBackgroundId>();
  overrideId = input<string | null>(null);

  selected = output<LabelPreviewBackgroundId>();

  readonly isMobile: Signal<boolean>;
  readonly backgroundOptions = LABEL_PREVIEW_BACKGROUNDS.map(bg => ({
    ...bg,
    smallBgImage: labelPreviewBgThumbStyle(getLabelPreviewBgSmallUrl(bg.id)),
  }));

  effectiveId = computed(() =>
    resolveLabelPreviewBgId(this.overrideId(), this.selectedId()) as LabelPreviewBackgroundId
  );

  constructor() {
    this.isMobile = inject(ResponsiveService).isMobile;
  }

  select(id: LabelPreviewBackgroundId): void {
    this.selected.emit(id);
  }
}
